<template>
  <v-dialog
    v-model="dialog"
    width="900"
  >
    <v-card>
      <v-card-title class="title">
        Add users
      </v-card-title>

      <v-divider />

      <v-card-text class="d-flex justify-space-between">
        <div style="max-width: 450px">
          <h1 class="checkbox__tree_title">Select users:</h1>
          <sl-extended-select
            :reduceColumnSize="true"
            v-model="form.instance_users"
            :data="instance_users"
            :withOptions="true"
            @updateUsersList="updateSelectedUsers($event)"
          />
        </div>
        <div class="checkbox__tree">
          <h1 class="checkbox__tree_title">Select articles:</h1>
          <v-treeview class="checkbox__tree_list" v-model="selectedArticles" :items="articles" selectable />
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="save"
          :disabled="!selectedArticles.length || !selectedUsers.length"
          :loading="loading"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SlExtendedSelect from '@/components/sl-extended-select.vue'

export default {
  name: 'AddUsersDialog',
  components: {
    SlExtendedSelect,
  },
  props: {
    articles: {
      type: Array,
      default: () => {
        return []
      }
    },
    users: {
      type: Array,
      default: () => {
        return []
      }
    },
    space: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      instance_users: [],
      form: {
        instance_user_id: 0,
        users: []
      },
      selectedUsers: [],
      selectedArticles: [],
      spaceUsers: [],
    }
  },
  methods: {
   async getUsers() {
     try {
       const allUsers = await this.$api.instance_users.list({ unlimit: 1 })

       this.instance_users = allUsers.data
     } catch (error) {
       console.log('components/spaces/add-users-dialog.vue getUsers', error)
     }
    },
    open() {
      this.getUsers()
      this.dialog = true
    },
    close(){
      this.dialog = false
      this.$emit('onClose')
    },
   async save() {
     try {
       this.loading = true

       await this.$api.spaces.save({ ...this.space, instance_users: this.spaceUsers })
       await this.bulkEdit()

       this.loading = false
       this.$notify({
         group: 'success',
         type: 'success',
         text: 'Saved'
       })
       this.close()

     } catch (error) {
       console.log('components/spaces/add-users-dialog.vue save', error)
     }
    },
    async bulkEdit () {
      try {
        const articlesIds = this.findParents(this.articles, this.selectedArticles)

        await this.$api.articles.bulkEdit({
          instance_users: this.selectedUsers,
          articles_ids: articlesIds
        })
      } catch (error) {
        console.log('components/spaces/add-users-dialog.vue bulkEdit', error)
      }
    },
    findParents(data, selectedIds) {
      let result = [];

      function traverse(node, path) {
        if (selectedIds.includes(node.id)) {
          result.push(...path, node.id);
        }

        if (node.children) {
          node.children.forEach(child => {
            traverse(child, [...path, node.id]);
          });
        }
      }

      data.forEach(item => traverse(item, []));

      return [...new Set(result)];
    },
    updateSelectedUsers (value) {
      this.spaceUsers = this.users.concat(value.map(item => ({
        ...item,
        pivot: {
          edit: false,
          delete: false,
        }
      })))
      this.selectedUsers = value.map(item => ({
        id: item.id,
        pivot: {
          edit: item.pivot.edit === 1 || item.pivot.edit === true,
          delete: item.pivot.delete === 1 || item.pivot.delete === true
        }
      }))
    },
  }
}
</script>
